import { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import {
    Box, Button, FormControl, FormLabel, Input, Stack, Text, useToast,
} from '@chakra-ui/react';

import { useAuth } from '../contexts/AuthContext';

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      await signIn(email, password);
      navigate("/");
    } catch (error) {
      toast({
        title: "Error",
        description:
          error instanceof Error ? error.message : "Failed to sign in",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box maxW="md" mx="auto" mt={8} p={6}>
      <form onSubmit={handleSubmit}>
        <Stack spacing={4}>
          <FormControl isRequired>
            <FormLabel>Email</FormLabel>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormControl>

          <FormControl isRequired>
            <FormLabel>Password</FormLabel>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormControl>

          <Button
            type="submit"
            colorScheme="blue"
            isLoading={isLoading}
            width="full"
          >
            Sign In
          </Button>

          <Text textAlign="center">
            Don't have an account?{" "}
            <RouterLink to="/register" style={{ color: "blue" }}>
              Register
            </RouterLink>
          </Text>

          <Text textAlign="center">
            <RouterLink to="/forgot-password" style={{ color: "blue" }}>
              Forgot password?
            </RouterLink>
          </Text>
        </Stack>
      </form>
    </Box>
  );
}
